import { ModalType } from '../../../Framework/Components/Modals/ModalTypes';
import Modal from '../../../Framework/Components/Modals/Modal';
import { SendDataProcess } from '../StandaloneSendForm';

import { MultiSendsUpload } from '../../Form/MultiSendsUpload';
import { useState } from 'react';
import { maxCloudflareFileSizeInBytes } from '../../../Api/SendMailEndpoints';

interface SendUploadModalType extends ModalType {
	sendData: SendDataProcess;
	uploadStartedCallback?: any;
	saveSendStartedCallback?: any;
}

const SendMultipleProcessingWizardModal = (props: SendUploadModalType) => {
	const [locked, setLocked] = useState<boolean>(true);

	return (
		<Modal title={'Send Items'} lockOpen={locked} isOpen={props.isOpen} closeCallback={() => props.closeCallback()}>
			<MultiSendsUpload
				name={'multiSends'}
				onError={(e) => console.log(e)}
				closeCallback={() => props.closeCallback()}
				queueStatusCallback={(state) => setLocked(state)}
				sendData={props.sendData}
				acceptsFileExtension={['.pdf']}
				extensionDisplayValue={'PDF'}
				maxSizeInBytes={maxCloudflareFileSizeInBytes}
				maxFiles={10}
			/>
		</Modal>
	);
};

export default SendMultipleProcessingWizardModal;
